<div class="wrapper-modal copy-to-my-list">
  <div class="wrapper-modal-content">
    <div class="wrapper-header-modal-copy-to-my-list">
      <span>{{'LIST_SINGLE_PAGE.add_item_to_list' | translate}}</span>
      <div (click)="closeModal.emit(true)" class="custom-btn custom-btn--circle-outline">
        <img src="./assets/icons/outline/icon-close-modal.svg" alt="">
      </div>
    </div>
    <button class="custom-btn custom-btn--outline" (click)="createNewList()">
      <img src="./assets/icons/outline/icon-plus.svg" alt="">
      <span>
        {{'LIST_SINGLE_PAGE.create_new_list' | translate}}
      </span>
    </button>
    <div class="wrapper-content-modal-copy-to-my-list">
      <div class="wrapper-tab-lists">
        <div class="wrapper-custom-radiobutton-list copy-item" #listContainer
        (scroll)="onScroll()" style="overflow-y: auto; height: 100%;">
          <!--    TODO JS - kad su disabled dodaje klasu "tl-not-allowed"      -->
          <label *ngFor="let list of lists" (click)="select(list)">
            <input type="radio" name="tag-list">
            <div class="custom-radiobutton">
              <div class="wrapper-language-info">
                <div class="wrapper-list-preview">
                  <div class="wrapper-image-list">
                    <img [src]="list.lyst_image_url !== null ? list.lyst_image_url : 'assets/images/no-image.png'"
                      alt="">
                  </div>
                  <div class="wrapper-info-list">
                    <span class="label-item">{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items'
                      |translate) : ('LISTS.items' |translate)}}</span>
                    <div class="info-list-tag">
                      <div class="title-list">
                        <span>{{list | matchLocale}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
    <button class="custom-btn custom-btn--primary" (click)="addItemToList()">
      <span>{{'LIST_SINGLE_PAGE.add_item_to_list' | translate}}</span>
    </button>
  </div>
</div>
